import createAPI from '../axios'
//import { config } from 'vue/types/umd';

//工作量相关API

const combineClassAdultEducation = {
    combineClass: {
        list: config => createAPI('/combineClassAdultEducation/list', 'post', config),
        siteTypeOption: config => createAPI('/combineClassAdultEducation/siteTypeOption', 'post', config),
        majorOption: config => createAPI('/combineClassAdultEducation/majorOption', 'post', config),
        classOption: config => createAPI('/combineClassAdultEducation/classOption', 'post', config),
        courseOption: config => createAPI('/combineClassAdultEducation/courseOption', 'post', config),
        querySkjh2List: config => createAPI('/combineClassAdultEducation/querySkjh2List', 'post', config),
        querySkjh3List: config => createAPI('/combineClassAdultEducation/querySkjh3List', 'post', config),
        changeSkjh: config => createAPI('/combineClassAdultEducation/changeSkjh', 'post', config),
        editRoom: config => createAPI('/combineClassAdultEducation/editRoom', 'post', config),
        checkpaike: config => createAPI('/combineClassAdultEducation/checkpaike', 'post', config),
        deleteHB: config => createAPI('/combineClassAdultEducation/deleteHB', 'post', config),
    },

};
export default combineClassAdultEducation;



// WEBPACK FOOTER //
// ./src/api/modules/combineClassAdultEducation.js